import React, { useEffect } from 'react'
import { connect } from "react-redux";
import { Card, CardTitle, CardBody } from "reactstrap";
import paginationFactory from "react-bootstrap-table2-paginator";
import BootstrapTable from "react-bootstrap-table-next";


// components
import TypeXpecialFilters from "./_filters";
import TranslateItem from "../../../components/genericComponents/translateItem";
import { GenericTableButton, TranslateButton } from "../../../components/buttons/buttonsActions";
import { ConfirmDelete } from "../../../components/confirmAlert/ConfirmDelete";
import { confirmAlert } from "react-confirm-alert";

// labels
import { LB_ACTIONS, LB_CODE, LB_TITLE, LIST, NO_DATA_FOUND } from "../../../components/i18n/i18n";
import { TT_DELETE, TT_EDIT } from "../../../components/i18n/toolTips";

// actions
import { setViewMode } from "../../../redux/actions/generalActions/mainActions";
import { setFilter, setTableParams } from "../../../redux/actions/generalActions/listActions";
import { setItem, setForm } from "../../../redux/actions/generalActions/formActions";
import { search, remove } from '../../../redux/actions/todoFluye/typeXpecialActions'

// services
import { aybAttributeService } from "../../../jwt/_services/ayb/aybAttributeService";

const TypeXpecialList = props => {
    const fbDataBaseId = props.mainState?.app?.fbDataBase?.id
    const { pageSize, pageIndex, totalSize, listDomainObjects, filter } = props.listState

    useEffect(()=>{
        if(!filter)
            props.setFilter({ code: null, group:null });
    },[])

    useEffect(()=>{
        if(!filter)
            return

        refreshDataList()
    },[filter, pageIndex, pageSize])

    const refreshDataList = () => props.search(pageIndex, pageSize, filter)

    const handleTableChange = (type, tableChangeParams) => {
        let currentIndex = (tableChangeParams.page - 1) * tableChangeParams.sizePerPage;
        props.setTableParams( tableChangeParams.sizePerPage, currentIndex );
    };

    const actionsFormatter = (cell, row) => <>
                <GenericTableButton toolTip={TT_EDIT} icon={'fa-pen'} permission={'edit'} onClick={() => {
                    props.setViewMode('FORM');
                    props.setItem(row);
                    props.setForm(true, false, false);
                }}/>
                <TranslateButton onClick={() => confirmTranslation(row)}/>
                <GenericTableButton toolTip={TT_DELETE} icon={'fa-trash'} permission={'delete'} onClick={() => confirmDelete(row)}/>
            </>

    const confirmTranslation = item => confirmAlert({
        closeOnEscape: false,
        closeOnClickOutside:false,
        customUI: ({onClose}) => <TranslateItem
            itemID = { item?.id }
            fbDB = { fbDataBaseId }
            onClose = { onClose }
            translate = { (itemID, fbDB) => aybAttributeService.translate(itemID, {
                db: fbDB,
                app: props?.mainProps?.app?.id,
            }) }
        />
    });

    const confirmDelete = data => ConfirmDelete({
        data,
        fbDataBaseId : fbDataBaseId,
        remove : props.remove
    });

    const columns = [
        {
            dataField: 'id',
            headerStyle: {width: '0px'},
            text: 'ID',
            hidden: true
        }, {
            dataField: 'code',
            text: `${LB_CODE}`
        }, {
            dataField: 'title',
            text: `${LB_TITLE}`
        }, {
            dataField: 'actions',
            text: `${LB_ACTIONS}`,
            headerAlign: 'center',
            align: 'center',
            headerStyle: {width: '200px'},
            formatter: actionsFormatter
        }
    ];

    return <Card>
        <CardTitle  className="bg-light border-bottom p-3 mb-0">
            <i className="far fa-list-alt mr-2"> </i>{ LIST }
        </CardTitle>

        <TypeXpecialFilters />

        <CardBody>
            <BootstrapTable
                striped hover
                tableHeaderClass='mb-0'
                remote
                keyField="id"
                data={listDomainObjects || [] }
                columns={columns}
                noDataIndication={ NO_DATA_FOUND }
                pagination={paginationFactory({pageIndex, pageSize, totalSize})}
                onTableChange={handleTableChange}
            />
        </CardBody>
    </Card>
}

const mapStateToProps = state => ({
    mainState: state.mainProps,
    listState : state.listProps,
})
const mapActionsToProps = ({
    setFilter,
    search,
    remove,
    setTableParams,
    setViewMode,
    setItem, setForm
})

export default connect(mapStateToProps, mapActionsToProps)(TypeXpecialList)